import React from "react";
import ArrowDown from "../assets/icons/ArrowDown";
import Rightarrow from "../assets/icons/Rightarrow";

import CartDetails from "./CartDetails";
import OrderSummary from "./OrderSummary";


const CartSummary = () => {
  return (
    <div className="cart-summary">
      <CartDetails />
      <OrderSummary />
      
    </div>
  );
};

export default CartSummary;
